(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller("ManagePlatformRentalListController", ManagePlatformRentalListController);

  ManagePlatformRentalListController.$inject = ["PlatformRentalService"];

  function ManagePlatformRentalListController(PlatformRentalService) {
    var vm = this;

    // vm.platformRentals = null;

    vm.flag = false;
    vm.getByFilter = getByFilter;
    vm.remove = remove;
    vm.sendPassword = sendPassword;
    vm.platformRentals = [];

    /* PAGINATION */
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.page = 1;

    activate();

    function setPage(page) {
      vm.currentPage = page;
    }

    function pageChanged(page) {
      vm.page = vm.currentPage;
      vm.getByFilter();
    }

    function activate() {
      vm.setPage(1);
      vm.getByFilter();
    }

    function getByFilter() {
      vm.flag = false;
      vm.query = {};
      vm.query["page"] = vm.page;
      PlatformRentalService.getPlatformRentals(vm.query)
        .then(function (response) {
          vm.platformRentals = response.data.data;
          vm.totalItems = response.data.total;
          if (vm.totalItems > 0) {
            vm.flag = true;
          }
          vm.itemsPerPage = response.data.per_page;
          vm.setPage(response.data.current_page);
        })
        .catch(function (err) { });
    }

    function remove(user) {
      alertify
        .confirm("This action is irreversible!")
        .set("labels", {
          ok: "Ok",
          cancel: "Cancelar",
        })
        .set("title", "Do you really want to delete this platform rental?")
        .set("onok", function () {
          PlatformRentalService.deletePlatformRental(user.id).then(function () {
            vm.platformRentals.splice(vm.platformRentals.indexOf(user), 1);
            alertify.notify("Platform Renal successfull removed", "success", 3);
          });
        })
        .show();
    }

    function sendPassword(platformRentalUser) {
      alertify
        .confirm('Send password for ' + platformRentalUser.name)
        .set('labels', {
          ok: 'Yes',
          cancel: 'No'
        })
        .set('title', 'Send user password')
        .set('onok', function () {
          PlatformRentalService.sendPassword(platformRentalUser.id).then(function () {
            alertify.notify('Platform rental user password successfull sended', 'success', 3);
          });
        })
        .show();
    }

  }
})();
